module.exports = __webpack_public_path__ + "img/bank-submit.386d8349.png";